module.exports = __webpack_public_path__ + "img/health.af6c4477.png";